import Fingerprint from "src/common/components/Fingerprint";

export default function FingerprintPage() {
  return <Fingerprint />;
}

FingerprintPage.noLayout = true;
